import React, { Component, PropTypes } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import { migrateBillingRegion, loadActiveBillingRegions } from '../../actions/ClientActions'
import Modal from '../../components/Modal'

@connect(state => ({
    isUpdatingBillingRegion: state.modal.isUpdatingBillingRegion,
    errorMigratingBillingRegion: state.modal.errorMigratingBillingRegion,
}))

export default class MigrateBillingRegionModal extends Component {
    static propTypes = {
        client: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }

    constructor(props) {
        super(props)
        this.state = {
            billingRegion: {},
            billingRegionOptions: [],
            shouldDeleteCreditCard: false
        }
    }

    migrate() {
        this.props.dispatch(
            migrateBillingRegion(
                this.props.client.id,
                this.state.billingRegion,
                this.state.shouldDeleteCreditCard
            )
        )
    }

    handleBillingRegionChange(v) {
        this.setState({
            billingRegion: {
                billingRegionId: v.value,
                name: v.label,
            },
        })
    }

    componentDidMount() { 
        this.props.dispatch(loadActiveBillingRegions(this.props.client.id))
        .then(data => {
            const options = data.result.map(region => { return {"label": region.name, "value": region.billingRegionId}});
            this.setState({
                billingRegionOptions: options,
            })
        })
    }

    render() {
        var actionButton = this.props.isUpdatingBillingRegion ? (
            <button className="btn btn-success disabled">Updating...</button>
        ) : (
            <button
                className="btn btn-success"
                onClick={this.migrate.bind(this)}
            >
                Migrate
            </button>
        )

        const value = this.state.billingRegion.billingRegionId
            ? {
                value: this.state.billingRegion.billingRegionId,
                label: this.state.billingRegion.name
              }
            : undefined

        return (
            <Modal
                actionButton={actionButton}
                className="modal modal-success"
                title={'Migrate Billing Region'}
            >
                {(this.props.client.billingRegion.name) && <h2>Current Billing Region: {this.props.client.billingRegion.name}</h2>}
                <label htmlFor='billingRegionName'>Select the billing region to migrate to:</label>
                <Select
                    placeholder="Select New Billing Region..."
                    multi={false}
                    name="billingRegionName"
                    value={value}
                    options={this.state.billingRegionOptions}
                    onChange={this.handleBillingRegionChange.bind(this)}
                />
                <br />
                <p>
                    Do you also want to delete the credit card associated with the client?
                    <input
                        style={{marginLeft: 10}}
                        type="checkbox"
                        checked={this.state.shouldDeleteCreditCard}
                        onChange={e => this.setState({shouldDeleteCreditCard: !this.state.shouldDeleteCreditCard})}
                    />
                </p>
                {this.props.errorMigratingBillingRegion && <p className='text-danger'>Error migrating client!</p>}
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/clients/MigrateBillingRegionModal.js